import AppLogoSvg from '../assets/images/tadreamk_logo.svg';

// Global application configuration (mirrors main website pattern)
export const APP_CONFIG = {
  // Brand assets
  LOGO_URL: AppLogoSvg,

  // Company/product information
  COMPANY_NAME: 'TadReamk',
  PRODUCT_NAME: 'Business Card Manager',

  // API Configuration
  API_BASE_URL:
    process.env.REACT_APP_API_URL || 'http://localhost:2510/api/v1',

  // Main Website API (for shared services like email)
  MAIN_WEBSITE_API_URL:
    process.env.REACT_APP_MAIN_WEBSITE_API_URL
    || 'http://localhost:2506/api/v1',

  // External website origin for deep links to main website
  MAIN_WEBSITE_ORIGIN:
    process.env.REACT_APP_MAIN_WEBSITE_ORIGIN || 'http://localhost:3000',

  // Social media links
  SOCIAL_LINKS: {
    LINKEDIN: 'https://www.linkedin.com/company/tadreamk/',
    GITHUB: 'https://github.com/tadreamk/tadreamk-python'
  }
};


